import { utils } from "@alife/cone-arms-core";
var hookHashChange = utils.hookHashChange, hookHistory = utils.hookHistory, getUrl = utils.getUrl, checkWin = utils.checkWin;
// 如果初始化插件时页面已经onload，直接发送pv
// 如果初始化插件时页面还没有onload，则等页面onload时再发送pv
var onLoad = function onLoad(callback) {
    var setTimeoutOnWindow = function setTimeoutOnWindow() {
        setTimeout(callback);
    };
    if (document.readyState === "complete") {
        setTimeout(callback);
    } else {
        window.addEventListener("load", setTimeoutOnWindow);
    }
    return function() {
        window.removeEventListener("load", setTimeoutOnWindow);
    };
};
var TracePvPlugin = function(core) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!(core && checkWin())) {
        return;
    }
    var _config_autoPV = config.autoPV, autoPV = _config_autoPV === void 0 ? true : _config_autoPV, _config_enableHash = config.enableHash, enableHash = _config_enableHash === void 0 ? false : _config_enableHash, _config_enableHistory = config.enableHistory, enableHistory = _config_enableHistory === void 0 ? false : _config_enableHistory;
    var uninstallHooks = [];
    var lastReportUrl = "";
    var timerId;
    var isRepeat = function() {
        return lastReportUrl === getUrl(core.getConfig());
    };
    var logPv = function() {
        var logInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // 避免重复上报
        if (!isRepeat()) {
            lastReportUrl = getUrl(core.getConfig());
            core.logPv(logInfo);
        }
    };
    var handleSpaPageChange = function() {
        clearTimeout(timerId);
        if (!isRepeat()) {
            logPv();
        } else {
            timerId = setTimeout(logPv, 50);
        }
    };
    if (autoPV) {
        uninstallHooks.push(onLoad(function() {
            logPv({
                changePage: false
            });
            if (enableHash) {
                uninstallHooks.push(hookHashChange(handleSpaPageChange));
            }
            if (enableHistory) {
                uninstallHooks.push(hookHistory(handleSpaPageChange));
            }
        }));
    }
    return uninstallHooks;
};
export default TracePvPlugin;

 //# sourceMappingURL=index.js.map